import React from 'react';
import { HomePage } from './pages/HomePage';
import { AssetLabelsPage } from './pages/AssetLabelsPage';
export function App() {
  // Simple path-based routing
  const path = window.location.pathname;
  if (path === '/products/asset-labels') {
    return <AssetLabelsPage data-id="element-0" />;
  }
  return <HomePage data-id="element-1" />;
}